import { render } from "./menueView.vue?vue&type=template&id=62f80382"
import script from "./menueView.vue?vue&type=script&lang=js"
export * from "./menueView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__